import getObjectValue from 'libs/getObjectValue'
import {SELECT_VALUE} from 'constants/VATItems';
import VatType from 'constants/VatType';
import {SOURCE_TYPES} from 'constants/OfferSourceTypes'

export default async (dealingElement, formikProps, rootId) => {
    if (dealingElement === undefined) {
        return;
    }
    const createId = key => `${rootId}.${key}`


    const emptyStage = {conditions: [], criterions: [], parameters: []}
    const oldStage = getObjectValue(createId('stages.0'), formikProps.values, emptyStage)
    const _open = getObjectValue(createId('_open'), formikProps.values)
    const _edit = getObjectValue(createId('_edit'), formikProps.values)
    const _touched = getObjectValue(createId('_touched'), formikProps.values)
    let stage = dealingElement.stages[0];
    if (!stage) stage = emptyStage

    const concatNoDuplicates = (a, b) => a.concat(
        b.filter(bElement => !a.find(
            aElement => bElement.identity === aElement.identity
        ))
    )

    const {amount, items, ...other} = dealingElement;
    let vatRate = amount.vatRate ? amount.vatRate : SELECT_VALUE.DEFAULT;
    let vatType = amount.vatType;
    let vatRateOther = undefined;
    if (vatType === VatType.OTHER) {
        vatRateOther = vatRate;
        vatRate = SELECT_VALUE.OTHER;
    } else if (vatType !== VatType.STANDARD) {
        vatRateOther = 0;
        vatRate = vatType;
    }

    const stages = [
        {
            ...stage,
            conditions: concatNoDuplicates(stage.conditions, oldStage.conditions),
            criterions: concatNoDuplicates(stage.criterions, oldStage.criterions),
            parameters: concatNoDuplicates(stage.parameters, oldStage.parameters),
        }
    ];

    const newItems = [];
    items.forEach(i => {
        const itemVatFormatted = _formatItemVat(i);
        let optionalItem = null;
        if (i.optionalItem != null) {
            const optionalItemVatFormatted = _formatItemVat(i.optionalItem);
            optionalItem = {
                ...i.optionalItem,
                offerVatRate: optionalItemVatFormatted.offerVatRate,
                offerVatRateOther: optionalItemVatFormatted.offerVatRateOther
            }
        }
        newItems.push({
            ...i,
            offerVatRate: itemVatFormatted.offerVatRate,
            offerVatRateOther: itemVatFormatted.offerVatRateOther,
            optionalItem: optionalItem
        })
    });

    const newDealingElement = {
        ...other,
        amount: {
            ...amount,
            vatRate,
            vatRateOther,
        },
        _open,
        _touched,
        _edit,
        stages,
        items: newItems
    }

    formikProps.setFieldValue(rootId, newDealingElement)
}

const _formatItemVat = (i) => {
    let offerVatRate = SELECT_VALUE.DEFAULT;
    let offerVatRateOther = undefined;
    if (i.offerVatPredefined || i.offerSourceType === SOURCE_TYPES.INITIATOR) {
        if (i.offerVatType === VatType.OTHER) {
            offerVatRateOther = i.offerVatValue;
            offerVatRate = SELECT_VALUE.OTHER;
        } else if (i.offerVatType !== VatType.STANDARD) {
            offerVatRateOther = 0;
            offerVatRate = i.offerVatType;
        } else {
            offerVatRate = i.offerVatValue.toString();
        }
    }
    return { offerVatRate: offerVatRate, offerVatRateOther: offerVatRateOther };
}